import React from "react";
import BlockReveal from "react-block-reveal-animation";
import clsx from "clsx";

export default function BlockRevealImage({
	blockRevealClass,
	imageClass,
	captionClass,
	isInView,
	imageSrc,
	imgAlt,
	imgAlt2,
	hasOtherElements,
	popovers,
	addShadowOnVisible,
}) {
  return isInView ? (
    <BlockReveal
      duration={1}
      delay={0}
      color="#E7E6E2"
      className={clsx(blockRevealClass)}
    >
      {hasOtherElements && popovers}
      <img className={clsx(imageClass, addShadowOnVisible && "boxShadowDelay")} alt={imgAlt} src={imageSrc} />
	  <div  className={captionClass}><strong>{imgAlt}</strong>{imgAlt2}</div>
    </BlockReveal>
  ) : (
    <div
      className={blockRevealClass}
      style={{ boxShadow: "none", cursor: "none" }}
    >
      <img
        className={imageClass}
        style={{ transform: "scale(0)", boxShadow: "none" }}
        alt={imgAlt}
        src={imageSrc}
      />
    </div>
  );
}
